import {
  STANDARD,
  DROPDOWN,
  SETTLEMENTS_STATUS_IMPORT_ITEMS,
} from 'baseConfig/pg/constants';

export default {
  [STANDARD]: {
    TABLE_COLUMNS: [
      {
        key: 'initiatedOn',
        displayName: 'Initiated At',
        width: 1.5,
      },
      {
        key: 'transactionPeriod',
        displayName: 'Transaction Period',
        width: 1.8,
      },
      {
        key: 'settlementId',
        displayName: 'Settlement ID',
        width: 1,
      },
      {
        key: 'fcyAmount',
        displayName: 'Settlement Amt. (FCY)',
        width: 1,
        align: 'right',
      },
      {
        key: 'fxRateFinal',
        displayName: 'Forex Rate (FCY/INR)',
        width: 1,
        align: 'right',
      },
      {
        key: 'netSettledAmount',
        displayName: 'Settlement Amt. (INR)',
        width: 1,
        align: 'right',
      },
      {
        key: 'importSettlementStatus',
        displayName: 'Status',
        width: 1,
      },
      {
        key: 'utr',
        displayName: 'SWIFT Reference',
        width: 1,
      },
      {
        key: 'downloadCta',
        displayName: 'SWIFT Confirmation',
        width: 1,
        align: 'center',
      },
    ],
    FILTER_ITEMS: {
      settlementStatus: {
        displayText: 'Status',
        type: DROPDOWN,
        items: SETTLEMENTS_STATUS_IMPORT_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'utrNo',
        text: 'SWIFT Ref.',
        value: 'utr',
        placeholder: 'Enter SWIFT Ref.',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'settlementId',
        text: 'Settlement ID',
        value: 'settlementId',
        placeholder: 'Enter Settlement Id',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
    ],
  },
};
